import { useQuery } from "@tanstack/react-query";
import { object, number } from "yup";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { smsSnippetSchema } from "./schemas";

const requestSchema = object({
  id: number().required(),
});

const responseSchema = smsSnippetSchema.required();

export const useSmsSnippetQuery = (payload, options = {}) => {
  return useQuery({
    queryKey: [QUERY_KEYS.smsSnippets.one, payload.id],
    queryFn: async () => {
      const req = requestSchema.validateSync(payload, {
        strict: true,
      });
      const res = await http.get(HTTP_ENDPOINTS.smsSnippets.getOne(req.id));
      return responseSchema.validateSync(res.data?.data, {
        strict: true,
      });
    },
    ...options,
  });
};
